import { styled } from 'styled-components';

export const StyledInstructionContainer = styled.div`
    color: var(--foundation-grey-10);
    background-color: var(--foundation-grey-3);
    padding: var(--spacing-5);
    margin-bottom: var(--spacing-4);
`;
